module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.resourceId
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [(!_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Basic information")]) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('translate', [_vm._v("SQL Application")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [(!_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.innerIp
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "prop": "serviceNameType"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.serviceNameType),
      callback: function($$v) {
        _vm.addForm.serviceNameType = $$v
      },
      expression: "addForm.serviceNameType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Service Name",
      "value": "service_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SID",
      "value": "sid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "prop": "serviceName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.serviceName),
      callback: function($$v) {
        _vm.addForm.serviceName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.serviceName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "word-wrap": "break-word"
    },
    attrs: {
      "label": _vm.attrText.database,
      "prop": "database"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.database),
      callback: function($$v) {
        _vm.addForm.database = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.database"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os
    }
  }, [(_vm.addForm.os === 'mssql') ? _c('span', [_vm._v("SQL Server")]) : (_vm.addForm.os === 'postgresql') ? _c('span', [_vm._v("PostgreSQL")]) : (_vm.addForm.os === 'oracle') ? _c('span', [_vm._v("Oracle")]) : _c('span', [_vm._v("MySQL")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disEditUsername
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.disEditUsername = !_vm.disEditUsername
        _vm.addForm.username = _vm.databaseObj.username
      }
    }
  }, [(_vm.disEditUsername) ? _c('translate', [_vm._v("Change")]) : _c('translate', [_vm._v("Cancel")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "如无需修改密码，则密码留空。",
      "disabled": _vm.disEditPassword
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.addForm.password = $$v
      },
      expression: "addForm.password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.disEditPassword = !_vm.disEditPassword
        _vm.addForm.password = ''
      }
    }
  }, [(_vm.disEditPassword) ? _c('translate', [_vm._v("Change")]) : _c('translate', [_vm._v("Cancel")])], 1)], 1)]), _vm._v(" "), _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.moreForm.moreSet = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("More")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "database-wrapper"
  }, [(_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.moreForm,
      "label-width": "120px",
      "show-message": false
    }
  }, [(!_vm.parentId) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.interceptionCommand
    }
  }, [_c('el-select', {
    staticClass: "inter-select",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    model: {
      value: (_vm.moreForm.action),
      callback: function($$v) {
        _vm.moreForm.action = $$v
      },
      expression: "moreForm.action"
    }
  }, _vm._l((_vm.moreForm.interceptsCommand), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item[0],
        "value": item[0]
      }
    })
  })), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.tableName,
      "disabled": _vm.addTable
    },
    model: {
      value: (_vm.moreForm.cellName),
      callback: function($$v) {
        _vm.moreForm.cellName = $$v
      },
      expression: "moreForm.cellName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.action === ''
    },
    on: {
      "click": function($event) {
        _vm.addCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-command"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.interception,
      "stripe": "",
      "empty-text": _vm.attrText.notCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "op",
      "label": _vm.attrText.command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "table",
      "label": _vm.attrText.tableName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.table ? scope.row.table : 'All') + "\n\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.setRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeCommand(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.sqlApprover
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1",
      "disabled": _vm.moreForm.setRadio === '0'
    },
    model: {
      value: (_vm.moreForm.sqlApprover),
      callback: function($$v) {
        _vm.moreForm.sqlApprover = $$v
      },
      expression: "moreForm.sqlApprover"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0",
      "disabled": _vm.moreForm.setRadio === '0'
    },
    model: {
      value: (_vm.moreForm.sqlApprover),
      callback: function($$v) {
        _vm.moreForm.sqlApprover = $$v
      },
      expression: "moreForm.sqlApprover"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.approver
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.moreForm.sqlApprover === '0'
    },
    model: {
      value: (_vm.moreForm.name),
      callback: function($$v) {
        _vm.moreForm.name = $$v
      },
      expression: "moreForm.name"
    }
  }, _vm._l((_vm.moreForm.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlApprover === '0'
    },
    on: {
      "click": function($event) {
        _vm.addApprover()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.approver,
      "stripe": "",
      "empty-text": _vm.attrText.noApprover
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.approver
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlApprover === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeApprover(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.sqlAlarmIntruct
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.moreForm.sqlAlarmIntruct),
      callback: function($$v) {
        _vm.moreForm.sqlAlarmIntruct = $$v
      },
      expression: "moreForm.sqlAlarmIntruct"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.moreForm.sqlAlarmIntruct),
      callback: function($$v) {
        _vm.moreForm.sqlAlarmIntruct = $$v
      },
      expression: "moreForm.sqlAlarmIntruct"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), (!_vm.parentId) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.alarmInstruction
    }
  }, [_c('el-select', {
    staticClass: "inter-select",
    attrs: {
      "placeholder": _vm.attrText.select,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.alarmAction),
      callback: function($$v) {
        _vm.moreForm.alarmAction = $$v
      },
      expression: "moreForm.alarmAction"
    }
  }, _vm._l((_vm.moreForm.interceptsCommand), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item[0],
        "value": item[0]
      }
    })
  })), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.tableName,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.alarmCellName),
      callback: function($$v) {
        _vm.moreForm.alarmCellName = $$v
      },
      expression: "moreForm.alarmCellName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    on: {
      "click": function($event) {
        _vm.addAlarmCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-command"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.alarmInterception,
      "stripe": "",
      "empty-text": _vm.attrText.notAlarmCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "op",
      "label": _vm.attrText.command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "table",
      "label": _vm.attrText.tableName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.table ? scope.row.table : 'All') + "\n\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeAlarmCommand(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.notifier
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.notifier),
      callback: function($$v) {
        _vm.moreForm.notifier = $$v
      },
      expression: "moreForm.notifier"
    }
  }, _vm._l((_vm.moreForm.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    on: {
      "click": function($event) {
        _vm.addNotifier()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.notifierList,
      "stripe": "",
      "empty-text": _vm.attrText.noNotifier
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.notifier
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeNotifier(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": (_vm.moreForm.sqlApprover === '1' && _vm.moreForm.approver.length === 0) || (_vm.moreForm.sqlAlarmIntruct === '1' && (_vm.moreForm.notifierList.length === 0 || _vm.moreForm.alarmInterception.length === 0))
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b64a444e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-database-setting.vue
// module id = 610
// module chunks = 4 5 6